module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAHpJREFUeNpi/P//PwO5gHFwaC4oKCBo0oQJExhx2pyfn4/TgIkTJzISdHZubi6G4OTJkxkJOXs1jP3v378QGJuJiWkNkrND8TkbxQBkjUBnhxLj7NVYnB1KdFRlZWXBDZg2bVooVkUgzbhwenr6anzyjMMgeZIKAAIMAIUBeZsCC7/gAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/folder_open.png
// module id = PK8p
// module chunks = 0